/** Optional host hook. The standalone build defines no provider and sends nothing. */
export interface CrushSeasonAnalyticsAdapter {
  pageView: (payload: { path: string; title: string }) => void;
  performance?: (payload: { loadMs: number }) => void;
}

declare global {
  interface Window {
    __CRUSH_SEASON_ANALYTICS__?: CrushSeasonAnalyticsAdapter;
  }
}

export function reportPublicPageMetrics(): void {
  const adapter = window.__CRUSH_SEASON_ANALYTICS__;
  if (!adapter) return;
  adapter.pageView({ path: window.location.pathname, title: document.title });
  const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  if (navigation && adapter.performance) adapter.performance({ loadMs: Math.round(navigation.loadEventEnd - navigation.startTime) });
}
